import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { myContext } from '../App';
import { Helmet } from 'react-helmet-async';
import ContactPopup from './contactPopup';
import ThankYouPopup from './thankyouPopUp';


export function BrokerServices() {

  // use useNavigate hook to redirect the user to any other page
  const navigate = useNavigate();
  // Import and use the useContext hook to access the data from app.jsx
  const footerContext = useContext(myContext);

  const [popup, setpopup] = useState(false)
  const [modalState, setModalState] = useState(null); // 'contact | thanks | null'
  
  useEffect(() => {}, [modalState]);
  const navigateTo = (path) => {
    footerContext.setRender(!footerContext.render);
    navigate(path)
  }
  const onContactUsClick = async () => {
    footerContext.setIsThankMessage(true);
    // setpopup(true);
    setModalState("contact");
}

  return <div>
    <Helmet>

      <title>Broker Services | Canon Financial Services</title>

      <meta name="description" content="See why CFS is dedicated to strong relationships with financial brokers. We offer minimal fees, streamlined documentation, and competitive pricing." />

      <link rel="canonical" href="https://www.cfs.canon.com/BrokerServices" />

    </Helmet>
    <div className="container-fluid position-relative px-0 industry-banner">
      <div className="">
        <img
          src="./images/broker-page-banner-image.jpg"
          className="img-fluid w-100 object-fit-cover"
          alt="..."
        />

      </div>
      <div className="container text-center banner-content-overlap position-absolute top-50 start-50 translate-middle">
        <h1>Dedicated Service, Strong Partnership</h1>
        <span className="d-inline-block mb-4 banner-description mt-4 w-75">
          CFS is dedicated to forming a strong partnership with Brokers like you.
          With minimal fees, streamlined documentation, and competitive pricing,
          its clear that we are your ideal financial partner.
        </span>
      </div>
    </div>
    {/* Banner Section Ends here */}
    {/* CTA Section Starts here */}
    {/* <div className="primary-gradient-bg text-center">
        <div className="cta-custom-width pb-4">
          <p className="font-34 secondary-color font-bold pt-3 mb-0 text-uppercase">
          ALREADY PART OF OUR BROKER NETWORK?
          </p>
        </div>
      </div> */}
    {/* CTA Section Ends here */}
    {/* Left and right Section Starts here */}
    <div className="container-fluid">
      <div className="py-2 my-4 mx-3 mx-lg-0 text-center d-flex justify-content-center flex-wrap">
        <h2 className="grey-color-v1 w-100">JOIN OUR NETWORK OF BROKERS</h2>

        <button onClick={() => { onContactUsClick() }} className="text-uppercase mt-2">
            CONTACT US
          </button>
          
      </div>
      <div className="row my-4 align-items-center grey-bg">
        <div className="col-md-6 px-0 order-1 order-md-1 left-right-sec-img">
          <img
            src="./images/Broker - Your success is our priority.jpg"
            className="section-img w-100"
            alt="section-img"
          />
        </div>
        <div className="col-md-6 order-2 order-md-1">
          <div className="left-i-and-right-c-sec-spacing">
            <div className="container">
              <h2 className="mb-3 grey-color-v1">Your Success is Our Priority</h2>
              <p className="font-20 font-regular line-height-26 mb-2">
                Canon Financial Services offers these things and more to support
                Brokers like you:
              </p>
              <ul className="success-list">
                <li className="font-20 font-regular">
                  Application only to $250,000
                </li>
                <li className="font-20 font-regular">
                  Approvals valid for 90 days
                </li>
                <li className="font-20 font-regular">
                  Multiple asset categories accepted
                </li>
                <li className="font-20 font-regular">Fast credit decisions</li>
                <li className="font-20 font-regular">
                  Discounting program available
                </li>
                <li className="font-20 font-regular">
                  3rd-party documentation accepted
                </li>
                <li className="font-20 font-regular">
                  A, B, and C credits accepted
                </li>
                <li className="font-20 font-regular">Single point of contact</li>
                <li className="font-20 font-regular">Easy on-boarding process</li>
                <li className="font-20 font-regular">And more!</li>
              </ul>
              {/* <button href="#" onClick={() => { navigateTo("/ContactUs") }} className="text-uppercase mt-3">
              CONTACT OUR BROKER TEAM
            </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Left and right Section Ends here */}
    {/* Icon box Section Starts here */}
    <div className="custom-container mb-5 pb-3">
      <div className="pt-5 pb-3 my-4 mx-3 mx-lg-0 text-center d-flex justify-content-center flex-wrap">
        <h2 className="grey-color-v1 w-100">WHY PARTNER WITH CFS ?</h2>
      </div>
      <div className="d-flex justify-content-center flex-wrap custom-broker-icon-box-section">
        <div className="d-w-25">
          <div className="card rounded-0 border-0 align-items-center core-values-card">
            <img
              src="./images/Broker - financial solutions.svg"
              className="card-img-top"
              alt="caring-hands"
            />
            <div className="card-body flex-wrap primary-color px-4 mb-4">
              <span className="font-bold font-20 mb-1 d-block text-center grey-color-v1">
                Range of Financial Solutions{" "}
                <span className="lg-line-breaker">Available</span>
              </span>
              <p className="card-text text-center">
                We offer EFAs, dollar out leases, operating leases, and so much
                more. We also accept multiple asset categories so you can tailor
                to your customers’ needs.
              </p>
            </div>
          </div>
        </div>
        <div className="d-w-25">
          <div className="card rounded-0 border-0 align-items-center core-values-card">
            <img
              src="./images/Broker - Personalized support.svg"
              className="card-img-top"
              alt="caring-hands"
            />
            <div className="card-body flex-wrap primary-color px-4 mb-4">
              <span className="font-bold font-20 mb-1 d-block text-center grey-color-v1">
                Outstanding Personalized{" "}
                <span className="lg-line-breaker">Support</span>
              </span>
              <p className="card-text text-center">
                Our broker team is dedicated to your success. A single point of
                contact will work with you to meet any criteria your customers may
                have.
              </p>
            </div>
          </div>
        </div>
        <div className="d-w-25">
          <div className="card rounded-0 border-0 align-items-center core-values-card">
            <img
              src="./images/Broker - apptoval.svg"
              className="card-img-top"
              alt="caring-hands"
            />
            <div className="card-body flex-wrap primary-color px-4 mb-4">
              <span className="font-bold font-20 mb-1 d-block text-center grey-color-v1">
                Accepting Approval{" "}
                <span className="lg-line-breaker">Philosophy</span>
              </span>
              <p className="card-text text-center">
                Getting approval for your dealers easily and quickly is key. We
                work with you to get the approvals you need while maintaining our
                clear credit philosophy.
              </p>
            </div>
          </div>
        </div>
        <div className="d-w-25">
          <div className="card rounded-0 border-0 align-items-center core-values-card">
            <img
              src="./images/Broker - competitve pricing.svg"
              className="card-img-top"
              alt="caring-hands"
            />
            <div className="card-body flex-wrap primary-color px-4 mb-4">
              <span className="font-bold font-20 mb-1 d-block text-center grey-color-v1">
                Competitive <span className="lg-line-breaker">Pricing</span>
              </span>
              <p className="card-text text-center">
                As your dependable financial partner, our goal is to keep you
                competitive. Our programs are structured to align with your
                business process.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center">
        {/* <button href="#" onClick={() => { navigateTo("/ContactUs") }} className="text-uppercase mt-3">
        CONTACT OUR BROKER TEAM
      </button> */}
      </div>
    </div>
    {modalState === "contact" && <ContactPopup closeContactPopup={() => setModalState(null)} onSuccess={() => 
            {
                setModalState("thanks");
                console.log('Modal state after success: ', modalState);

            }} />} 
        {modalState === "thanks" && 
        <>
        ({console.log('rednering thank you pop up')})
        <ThankYouPopup closeThankYou={() => setModalState(null)} />
        </>}
  </div>



}